// removed by extract-text-webpack-plugin
module.exports = {"header":"_2AQKKHjD","header-content":"_1poUZ8Ug","headerContent":"_1poUZ8Ug","sub-title":"tMg5aldl","subTitle":"tMg5aldl","name":"_3o7UhAX9","job-title":"_3YNqY4SS","jobTitle":"_3YNqY4SS","company":"VCEO2D52","menu":"_2XX5xouC","hide":"_1kuIMh0g","menu-icon":"_1n1UmkFi","menuIcon":"_1n1UmkFi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.pcss
// module id = 374
// module chunks = 0